import type { AiAgentEmailPayload, EmailThread } from "app/pages/sales-intelligence/modules/ai-agent/types/email";
import type { FeedbackDto } from "app/pages/sales-intelligence/modules/ai-agent/types/thread";
import type {
    ForceResultWithFullResponse,
    GetRequestOptions,
    IFetchService,
    PostConfigObject,
} from "app/services/fetchService";

const DEFAULT_URL = "/sales-api/ai-craft-email-agent";
const THREADS_URL = `${DEFAULT_URL}/threads`;

export default function createEmailAgentApiService(apiClient: IFetchService) {
    return {
        createAIEmailAgentThread: (
            payload: AiAgentEmailPayload,
            options?: Readonly<PostConfigObject>,
        ): Promise<ForceResultWithFullResponse<string>> => {
            return apiClient.post(`${THREADS_URL}`, payload, options);
        },
        applyEmailPreview: (
            { threadId, content }: { threadId: string; content: string },
            options?: Readonly<GetRequestOptions>,
        ): Promise<ForceResultWithFullResponse<void>> => {
            return apiClient.post(`${THREADS_URL}/${threadId}/message-previews/apply`, { content }, options);
        },
        putAIAgentMessageFeedback: (
            { threadId, messageId, liked }: FeedbackDto,
            options?: Readonly<GetRequestOptions>,
        ): Promise<void> => {
            return apiClient.put(
                `${THREADS_URL}/${threadId}/messages/${messageId}/feedback?liked=${liked}`,
                undefined,
                options,
            );
        },
        postAIEmailAgentMessage: (
            {
                threadId,
                message,
            }: {
                threadId: string;
                message: string;
            },
            options?: Readonly<PostConfigObject>,
        ): Promise<ForceResultWithFullResponse<string>> => {
            return apiClient.post(`${THREADS_URL}/${threadId}/messages`, { message }, options);
        },
        applyCompetitors: (
            { threadId, competitors }: { threadId: string; competitors: { domain: string }[] },
            options?: Readonly<GetRequestOptions>,
        ): Promise<ForceResultWithFullResponse<void>> => {
            return apiClient.post(`${THREADS_URL}/${threadId}/competitors/apply`, { competitors }, options);
        },
        cancelCompetitors: (
            { threadId }: { threadId: string },
            options?: Readonly<GetRequestOptions>,
        ): Promise<ForceResultWithFullResponse<void>> => {
            return apiClient.post(`${THREADS_URL}/${threadId}/competitors/cancel`, {}, options);
        },
        getThreadById: (
            { threadId }: { threadId: string },
            options?: Readonly<GetRequestOptions>,
        ): Promise<EmailThread> => {
            return apiClient.get(`${THREADS_URL}/${threadId}`, undefined, options);
        },
    };
}
